import axios, { type AxiosResponse } from 'axios'

import type {
    ReportMaterialReservationPayloadSchema,
    ReportMaterialsApiResponseSchema,
    ReportMaterialTypesResponseSchema
} from '@/api/schemas/reports/reportMaterials'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'

class ReportMaterialsQueries {
    getReportMaterialTypes(): Promise<AxiosResponse<ReportMaterialTypesResponseSchema>> {
        return axios.get<ReportMaterialTypesResponseSchema>(API_ENDPOINTS.REPORTS.MATERIALS.MATERIAL_TYPES)
    }

    getReportMaterials(materialTypeId?: number | null): Promise<AxiosResponse<ReportMaterialsApiResponseSchema>> {
        return axios.get<ReportMaterialsApiResponseSchema>(API_ENDPOINTS.REPORTS.MATERIALS.MATERIALS, {
            params: {
                materialType_id: materialTypeId || undefined
            }
        })
    }

    createReportMaterialReservation(payload: ReportMaterialReservationPayloadSchema): Promise<AxiosResponse<unknown>> {
        const body = Array.isArray(payload) ? { reportMaterialReservations: payload } : payload

        return axios.post<unknown>(API_ENDPOINTS.REPORTS.MATERIALS.CREATE_REPORT_MATERIAL_RESERVATIONS, body)
    }
}

export default new ReportMaterialsQueries()
